/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useMutation } from 'react-query';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import './_COIs.scss';
import type { IvendorChange } from './types';

interface Iprops {
  vendorList: IvendorChange[];
  defaultValue: number | string | null;
  id: number | string;
}
export default function ComboBox(props: Iprops): JSX.Element {
  const { vendorList, defaultValue, id } = props;
  const { enqueueSnackbar } = useSnackbar();
  const setDefaultValue = vendorList.filter((item) => item.value === defaultValue);

  const { mutate: setVendorCategory } = useMutation(async (payload: number | null | undefined) => axios({
    url: `/api/coi/${id}/`,
    method: 'patch',
    data: {
      vendor_category: payload,
    },
  }), {
    onSuccess: () => {
      enqueueSnackbar('Vendor Category Selected Successfully!');
    },
    onError: () => {
      enqueueSnackbar('Failed!', { variant: 'error' });
    },
  });

  const changeHandler: (event: React.SyntheticEvent, value: IvendorChange | null,) => void = (e, value) => {
    if (value?.value === -1) {
      setVendorCategory(null);
    } else {
      setVendorCategory(value?.value);
    }
  };

  return (
    <Autocomplete
      disablePortal
      className='vendor-select'
      id='combo-box-demo'
      onChange={changeHandler}
      defaultValue={setDefaultValue.length > 0 ? setDefaultValue[0] : { label: 'vendor category', value: 0 }}
      options={vendorList}
      renderInput={(params): React.ReactNode => <TextField {...params} hiddenLabel className='vendor-select' />}
    />
  );
}
